export const LOGIN_URL = '/login';
export const MACHINES_INDEX_URL = '/machines';
export const CLIENTS_INDEX_URL = '/clients';
